import {Keys, StateValues} from './ts/redux/Datastore'

// AWH Once all of CMS View has migrated to Typescript, this this file will go away

// KEYS

(window as any).KEY_API_GATEWAY  = Keys.API_GATEWAY;
//(window as any).KEY_API_TOKEN  = Keys.API_TOKEN;
(window as any).KEY_SUPPORTED_BROWSER = Keys.SUPPORTED_BROWSER;

(window as any).SITEMAP_URL  = Keys.SITEMAP_URL;
(window as any).KEY_DRAWINGS_INFO_DATA_HASH = Keys.HASH_DRAWINGS_INFO_DATA;

(window as any).KEY_ID_SEGMENT  = Keys.ID_SEGMENT;
(window as any).KEY_CUSTOMER_NAME  = Keys.CUSTOMER_NAME;
(window as any).KEY_ID_CUSTOMER  = Keys.ID_CUSTOMER;
(window as any).KEY_TILES_URL   = Keys.TILES_URL;
(window as any).KEY_BUILDING_P1P2   = Keys.BUILDING_P1P2;
(window as any).STATE_CREATING_ATTACHMENT_VOID = StateValues.STATE_CREATING_ATTACHMENT_VOID;
(window as any).KEY_DATA_PUSHPIN_COORDS = Keys.KEY_DATA_PUSHPIN_COORDS;
(window as any).KEY_BUILDING_WO_COUNT = Keys.KEY_BUILDING_WO_COUNT;
(window as any).KEY_TOKEN_IS_BAD = Keys.TOKEN_IS_BAD;

(window as any).ts_temp__keys  = Keys;
(window as any).ts_temp__state_values  = StateValues;
